import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  ResponsiveContainer, CartesianGrid, LineChart, ReferenceLine, Line, Tooltip, XAxis, YAxis,
} from 'recharts';
import {monthAndYear} from '../../../../common/constants/datesFormat';
import ReferenceLineLabel from './referenceLineLabel';

class LeadTimeChart extends Component {
  constructor(props) {
    super(props);
    this.renderTooltip = this.renderTooltip.bind(this);
    this.renderActiveDot = this.renderActiveDot.bind(this);
  }

  render() {
    const {data, average} = this.props;
    const meanDeviation = this.getMeanDeviation(data, average);

    if (!data || data.length === 0) {
      return (<div></div>);
    }

    return (
      <div className='chart'>
        <ResponsiveContainer width='100%' height={350}>
          <LineChart data={data}
            margin={{'top': 5, 'right': 70, 'left': 5}}>
            <XAxis dataKey="order" tick={false}/>
            <YAxis axisLine={false} domain={['auto', 'auto']}/>
            <CartesianGrid strokeDasharray="3 3" vertical={false}/>
            <Tooltip content={this.renderTooltip}/>
            <Line
              type="linear"
              dataKey="leadtime"
              stroke="#47CBFF"
              strokeWidth={3}
              dot={{'stroke': '#47CBFF', 'strokeWidth': 1, 'fill': '#47CBFF'}}
              activeDot={this.renderActiveDot}
            />
            <ReferenceLine
              y={average}
              stroke="#9B9B9B"
              strokeWidth={2}
              strokeDasharray="8,5"
              label={<ReferenceLineLabel text='PROM' />}
            />
            {meanDeviation > 1 &&
            <ReferenceLine
              y={average - meanDeviation}
              stroke="#EB0A1E"
              strokeWidth={2}
              label={<ReferenceLineLabel text='MIN' />}
            />}
            {meanDeviation > 1 &&
            <ReferenceLine
              y={average + meanDeviation}
              stroke="#EB0A1E"
              strokeWidth={2}
              label={<ReferenceLineLabel text='MAX' />}
            />}
          </LineChart>
        </ResponsiveContainer>
        <div className='months-list'>
          {this.getMonths()}
        </div>
      </div>
    );
  }

  getMeanDeviation(list = [], average) {
    if (list.length === 0) {
      return 0;
    }

    const deviationsSum =
      list.reduce((sum, element) => sum + Math.abs(element.leadtime - average), 0);

    return deviationsSum / list.length;
  }

  getMonths() {
    const months = [];

    for (let i = 6; i >= 0; i--) {
      months.push(moment().subtract(i, 'months').format(monthAndYear));
    }

    return months.map((element) => {
      return (
        <div className='month'>
          {element}
        </div>
      );
    });
  }

  renderTooltip({active, payload, label}) {
    if (!active) {
      return null;
    }

    const {data} = this.props;
    const index = data.findIndex((element) => element.order === label);

    return (
      <div className='lead-time-tooltip'>
        {`${index + 1} - Pedido ${label} - ${payload[0].value} Días`}
      </div>
    );
  }

  renderActiveDot({cx, cy, value, payload}) {
    const {onActiveDotClick} = this.props;
    return (
      <g className='recharts-layer recharts-active-dot'>
        <circle
          r={4}
          stroke='#47CBFF'
          strokeWidth={1}
          fill='white'
          cx={cx}
          cy={cy}
          onClick={onActiveDotClick.bind(this, payload.order)}
        />
      </g>
    );
  }
}

LeadTimeChart.propTypes = {
  'data': PropTypes.arrayOf(PropTypes.object).isRequired,
  'average': PropTypes.number.isRequired,
  'onActiveDotClick': PropTypes.func.isRequired,
};

export default LeadTimeChart;
